import {useCallback, useEffect, useState} from 'react';

const Image = ({fallbackSrc, src, alt, ...props}) => {
    const [failed, setFailed] = useState(false);
    // Reset failed state when src changes.
    useEffect(() => setFailed(false), [src]);
    const handleError = useCallback(() => setFailed(true), [setFailed]);
    return <img src={failed ? fallbackSrc : src} alt={alt} onError={handleError} {...props} />;
};

export default Image;
